//Creates new PlantTank and assigns ID and type
export const createPlantTank = (data) => {
    //data = {id, type}
    return { type: "CREATE_PLANT_TANK", payload: data}
}
